// @flow
import React, { useState } from 'react';
import styled from 'styled-components';

import { CopyToClipboardIcon } from '../icons/CopyToClipboardIcon';

const CopyableToastContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;

  i.icon {
    flex-shrink: 0;
    margin-top: 2px;
    position: sticky;
    top: 0;
  }
`;

export const CopyableToastContent = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (event) => {
    event.stopPropagation();
    await navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <CopyableToastContentWrapper>
      {text}
      <CopyToClipboardIcon copied={copied} onClick={handleCopy} />
    </CopyableToastContentWrapper>
  );
};
